<template>
  <div id="home-container">
    <router-view />
    <div
      class="showNav"
      @click="isShow=!isShow"
    >
      <van-icon
        :name="isShow?'qr':'qr-invalid'"
        color="#3C50E0"
      />
    </div>
    <div
      class="footerNav"
      v-show="isShow"
    >
      <div
        class="navL"
        @click="toNav('/questionnaireList')"
      >
        <van-icon name="records" />
        <span>我要答题</span>
      </div>
      <div
        class="navM"
        @click="toNav('/mutualHelpList')"
      >
        <van-icon name="description" />
        <span>互助问卷</span>
      </div>
      <div
        class="navR"
        @click="toNav('/userAccount')"
      >
        <van-icon name="cash-back-record" />
        <span>我的账户</span>
      </div>
      <!-- <div
        class="navR"
        @click="toNav('/userAccountNew')"
      >
        <van-icon name="cash-back-record" />
        <span>我的账户</span>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: true
    }
  },
  components: {},
  methods: {
    // 导航跳转
    toNav(path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>
<style lang='less'>
html,
body,
#app,
#home-container {
  width: 100%;
  height: 100%;
  //overflow: hidden;
}
#home-container {
  position: relative;
  .footerNav {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 40px;
    background: @colorDefault;
    display: flex;
    padding: 8px 0;
    box-sizing: border-box;
    color: #fff;
    .navL {
      flex: 1;
      height: 100%;
      border-right: 1px solid #fff;
      display: flex;
      font-size: 12px;
      align-items: center;
      justify-content: center;
      .van-icon {
        font-size: 18px;
        margin-right: 5px;
      }
    }
    .navM {
      flex: 1;
      height: 100%;
      border-right: 1px solid #fff;
      display: flex;
      font-size: 12px;
      align-items: center;
      justify-content: center;
      .van-icon {
        font-size: 18px;
        margin-right: 5px;
      }
    }
    .navR {
      flex: 1;
      height: 100%;
      display: flex;
      font-size: 12px;
      align-items: center;
      justify-content: center;
      .van-icon {
        font-size: 18px;
        margin-right: 5px;
      }
    }
  }
  .showNav {
    position: absolute;
    right: 10px;
    bottom: 60px;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: rgba(0, 0, 0, 0.2);
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
